import styled, { css } from 'styled-components';
import customCss from '@/app/components/hotel-detail/css/customCss';
import { toTADisplayScore } from './tripadvisor.helper';

type TripAdvisorScoreSize = 'inline' | 'medium' | 'large' | 'display';

type TripAdvisorScoreProps = {
  /** Raw 0–100 aggregate score from Supply. */
  rawScore: number;
  /**
   * `inline` – 14px, within a text row (cards, hero summaries), better for our custom owl height of 16px.
   * `medium` – 16px, better for owl minimum height of 20px.
   * `large`  – 34px, reviews section / ratings popover header.
   * `display` – 34px on mobile, scales to the DS Display style (56px) on desktop — reviews modal header.
   */
  size?: TripAdvisorScoreSize;
  className?: string;
};

// Plain bold score number, per the Figma DS `TripadvisorRatingScore` component — a bare number
// (no coloured badge/box) shown to the LEFT of the Ollie owl + bubbles. Colour is the neutral
// textPrimary token (#1e0023); the score is NOT tinted by the rating band.
const ScoreNumber = styled.span<{ $size: TripAdvisorScoreSize }>`
  flex-shrink: 0;
  font-weight: 700;
  color: ${({ theme }) => theme.kallisto.color.text.static.textPrimary};
  font-size: ${({ $size }) => ($size === 'inline' ? '14px' : $size === 'medium' ? '16px' : '34px')};
  line-height: ${({ $size }) => ($size === 'inline' ? '20px' : $size === 'medium' ? '24px' : '40px')};

  ${({ $size }) =>
    $size === 'display' &&
    css`
      @media ${customCss.breakpoints.sm} {
        font-size: 56px;
        line-height: 68px;
      }
    `}
`;

export default function TripAdvisorScore({ rawScore, size = 'inline', className }: TripAdvisorScoreProps) {
  return (
    <ScoreNumber $size={size} className={className}>
      {toTADisplayScore(rawScore)}
    </ScoreNumber>
  );
}
